function getNearbyBlock(actions, query, id) {
  if (!query || !actions) {
    return;
  }
  id = id ?? query.getEvent("selected").first();
  if (!id) return;

  const parents = query.node(id).ancestors();
  if (!parents || parents.length === 0) {
    return;
  }
  const parent = parents[0];

  const children = query.node(parent).childNodes();
  if (!children || children.length === 0) {
    return;
  }

  const index = children.indexOf(id);

  const nextSibling = children[index + 1];

  if (nextSibling) {
    return nextSibling;
  }

  const previousSibling = index > 0 ? children[index - 1] : null;

  if (previousSibling) {
    return previousSibling;
  }

  return parent;
}

function deleteB(actions, query, id) {
  if (!query || !actions) {
    return;
  }
  id = id ?? query.getEvent("selected").first();
  if (!id) return;

  // Get all child elements of parent and select the next element if it exists
  const parents = query.node(id).ancestors();
  if (!parents || parents.length === 0) {
    return;
  }

  const nearbyBlock = getNearbyBlock(actions, query, id);

  if (nearbyBlock) {
    actions.selectNode(nearbyBlock);
  }

  actions.delete(id);
}

export default deleteB;
